import React, { FC } from "react";

import { Button, ButtonProps, useTheme } from "@mui/material";

const PURPLE_GRADIENT_BACKGROUND =
  "linear-gradient(135deg, rgb(152, 16, 250) 0%, rgb(21, 93, 252) 100%)";

const PURPLE_GRADIENT_HOVER_BACKGROUND = `linear-gradient(135deg, #6D28D9 0%, #172AB6 100%)`;
export const IgPurpleGradientButton: FC<ButtonProps> = (props) => {
  const theme = useTheme();

  const {
    children,
    onClick,
    loading,
    sx,
    variant = "contained",
    color = "primary",
    startIcon,
    endIcon,
    ...rest
  } = props;

  const isPrimaryContained = variant === "contained" && color === "primary";

  return (
    <Button
      disableElevation
      loading={loading}
      startIcon={loading ? undefined : startIcon}
      endIcon={loading ? undefined : endIcon}
      sx={{
        ...(variant === "text" && {
          "& .MuiLoadingButton-loadingIndicator": {
            paddingRight: "50px",
          },
        }),
        ...(isPrimaryContained && {
          minHeight: "32px",
          minWidth: "fit-content",
          borderRadius: "6px",
          padding: theme.spacing(2, 3),
          gap: theme.spacing(2),
          fontSize: "12px",
          fontWeight: 600,
          lineHeight: "16px",
          letterSpacing: "0px",
          backgroundColor: theme.palette.accent.main,
          background: PURPLE_GRADIENT_BACKGROUND,
          "&:hover, &:active, &:focus": {
            backgroundColor: theme.palette.accent.main,
            backgroundImage: PURPLE_GRADIENT_HOVER_BACKGROUND,
          },
          "&.Mui-disabled": {
            backgroundImage: "none",
          },
        }),
        ...sx,
      }}
      {...rest}
      variant={variant}
      color={color}
      onClick={Boolean(loading) && Boolean(onClick) ? undefined : onClick}
    >
      {!loading && children}
    </Button>
  );
};
